import API from '../interceptors/Api';

const BASE_URL = '/deposit-applications';

export const getDepositApplication = (applicationId) => API.get(`${BASE_URL}/${applicationId}`);

export const getDepositApplications = (params) => API.get(BASE_URL, {
  params,
});

export const getDepositApplicationsAggregations = (params) => API.get(`${BASE_URL}/aggregations`, {
  params,
});

export const getDepositApplicationsExpired = (params) => API.get(`${BASE_URL}/expirations`, {
  params,
});

export const getDepositApplicationsToExpire = (params) => API.get(`${BASE_URL}/to-expire`, { params });
